import { FunctionComponent } from 'react';

import { NOTIFICATION_TYPES } from '@savgroup-front-common/constants';

import { Banner } from '../../atoms/Banners';
import { SafeFormattedMessageWithoutSpread } from '../../formatters';

import messages from './messages';

const OneProductPerClaimBanner: FunctionComponent = () => (
  <Banner
    isOpen
    hollow
    isFluid
    withMarginBottom
    dataTestId="oneProductPerClaimBanner"
    notificationType={NOTIFICATION_TYPES.INFO}
  >
    <SafeFormattedMessageWithoutSpread
      message={messages.oneProductPerClaimBanner}
    />
  </Banner>
);

export default OneProductPerClaimBanner;
